// extracted by mini-css-extract-plugin
module.exports = {"root":"GoalDetail_root__1TdZQ","header":"GoalDetail_header__UzeEa"};